export enum NotificationFilterTypes {
	ALL_TYPES = 'All Types',
	ANNOUNCEMENTS = 'Announcements',
	COMMENTS = 'Comments',
	STATUS_CHANGES = 'Status Changes',
	FOR_REVIEW = 'For Review',
	SYSTEM_GENERATED_EMAIL = 'Automated Emails',
	UNREAD = 'Unread'
}

export enum NOTIFICATION_ICON_NAMES {
	ALL_TYPES = 'fa-globe',
	ANNOUNCEMENTS = 'fa-bullhorn',
	COMMENTS = 'fa-comments',
	FOR_REVIEW = 'fa-flag',
	STATUS_CHANGES = 'fa-file-text-o',
	APPLICATION_STATUS_CHANGES = 'a-file-text-o',
	APPEAL_STATUS_CHANGES = 'fa_user',
	SYSTEM_GENERATED_EMAIL = 'fa-envelope-o',
	UNREAD = 'fa-bell'
}
